import { useState } from 'react'

import { CFlex, CMargin, DText } from '../../../../../styles/CommonStyles'
import Text from '../../../../../core/utils/Text'
import { deepCopy } from '../../../../../core/utils/common'
import Input from '../../../../common/input/Input'
import { UserDetailSettingBox } from '../../../../../styles/main/user'
import ActionButton from '../../../../common/buttons/ActionButton'
import { useQueryContext } from '../../../../../core/contexts/query'
import {
    useGetUserCardBalance,
    useWithdrawUserCardBalance,
} from '../../../../../core/services/react-query/report/cards'

const ChangeCardBalance = ({ user }) => {
    const { setToast } = useQueryContext();
    const [amount, setAmount] = useState('');

    const { mutate, isLoading } = useWithdrawUserCardBalance(() => {setAmount('')})

    const {
        data: cardBalance,
        isLoading: isGettingCardBalance,
    } = useGetUserCardBalance(user?._id)


    const availableBalance = Number(cardBalance?.balance?.available || 0)
    const numericAmount = Number(amount || 0)

    const validAction = Boolean(
        !isGettingCardBalance &&
        amount &&
        numericAmount > 0 &&
        numericAmount <= availableBalance &&
        numericAmount >= 2
    )

    const onSubmitClicked = async () => {
        if (!validAction || isLoading) return

        const payload = deepCopy({
            amount: numericAmount,
        })

        mutate(
            {
                userId: user?._id,
                payload,
            },
        )
    }

    return (
        <CFlex fw>
            <UserDetailSettingBox>
                <CMargin margin={'8px'} />

                <DText main fontSize={'s'}>
                    <Text tid={'available_balance'} />:{' '}
                    {availableBalance} USD
                </DText>

                <CMargin margin={'8px'} />

                <DText main fontSize={'s'}>
                    <Text tid={'volume'} />
                </DText>

                <CMargin margin={'4px'} />

                <Input
                    placeholder="Minimum 2 USD"
                    value={amount}
                    onInputChange={setAmount}
                    size={'small'}
                    number
                    padding={'0'}
                />

                <CMargin margin={'8px'} />

                <ActionButton
                    active={validAction}
                    onClick={onSubmitClicked}
                    loading={isLoading || isGettingCardBalance}
                >
                    <Text tid={'submit'} />
                </ActionButton>
            </UserDetailSettingBox>
        </CFlex>
    )
}

export default ChangeCardBalance
